var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.799 1.804H7.476v-.88A.424.424 0 007.053.5H3.947a.424.424 0 00-.424.424v.88H1.201a.424.424 0 00-.424.424v1.304c0 .234.19.424.424.424h8.597c.235 0 .424-.19.424-.424V2.228a.424.424 0 00-.423-.424zm-3.17 0H4.37v-.456H6.63v.456zM1.366 4.804l.352 8.29c.01.227.196.406.423.406H8.86a.424.424 0 00.423-.406l.352-8.29H1.366zm2.853 6.972a.424.424 0 01-.848 0V6.528a.424.424 0 01.848 0v5.248zm1.705 0a.424.424 0 01-.848 0V6.528a.424.424 0 01.848 0v5.248zm1.705 0a.424.424 0 01-.848 0V6.528a.424.424 0 01.848 0v5.248z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.adfbb17578e236f5c4c1a39c126123d6.svg";
export { ForwardRef as ReactComponent };